import React from 'react'
import IconButton from '@mui/material/IconButton'
import Badge from '@mui/material/Badge'
import Tooltip from '@mui/material/Tooltip'
import GppGoodIcon from '@mui/icons-material/GppGood'
import { Link, usePage } from '@inertiajs/react'

export function ApprovalBadge() {
  const { pending_approvals_count } = usePage().props as any

  return (
    <Tooltip title="Approvals">
      <IconButton
        component={Link}
        href="/manage/approvals"
        size="small"
        sx={{ color: 'text.secondary', mr: 0.5 }}
      >
        <Badge
          badgeContent={pending_approvals_count}
          color="warning"
          max={99}
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.65rem',
              height: 16,
              minWidth: 16,
            },
          }}
        >
          <GppGoodIcon sx={{ fontSize: 20 }} />
        </Badge>
      </IconButton>
    </Tooltip>
  )
}
